export const formatCoordinates = (
  coords: { lat: number; lng: number },
  setOriginalCoord?: (coord: { lat: number; lng: number }) => void,
  format: "decimal" | "dms" | "simple" = "decimal"
): string => {
  if (setOriginalCoord) {
    setOriginalCoord({ lat: coords.lat, lng: coords.lng });
  }

  switch (format) {
    case "simple":
      return `${coords.lat.toFixed(6)}, ${coords.lng.toFixed(6)}`;

    case "dms":
      return `${convertToDMS(coords.lat, "lat")} ${convertToDMS(coords.lng, "lng")}`;

    case "decimal":
    default:
      return `${coords.lat.toFixed(6)}, ${coords.lng.toFixed(6)}`;
  }
};

function convertToDMS(coord: number, type: "lat" | "lng"): string {
  const absolute = Math.abs(coord);
  const degrees = Math.floor(absolute);
  const minutesFloat = (absolute - degrees) * 60;
  const minutes = Math.floor(minutesFloat);
  const seconds = (minutesFloat - minutes) * 60;

  let direction: string;
  if (type === "lat") {
    direction = coord >= 0 ? "N" : "S";
  } else {
    direction = coord >= 0 ? "E" : "W";
  }

  return `${degrees}°${minutes}'${seconds.toFixed(1)}"${direction}`;
}
